module.exports = __webpack_public_path__ + "img/ingles.b9eaffbb.svg";